module.exports = __webpack_public_path__ + "static/img/wood111.8c3c9a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood111.jpg
// module id = /waA
// module chunks = 0